module.exports = __webpack_public_path__ + "img/p1_r.4d8917a2.jpg";